module.exports = __webpack_public_path__ + "img/UPS2.4307c3ae.png";